import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

// import hero_2 from "";
// import hero_3 from "../images/hero_3.png";
// import bucket from "../images/hero_3_2.png";
// import buckets from "../images/Bucket.jpeg";
// import basin from "../images/basin.jpg";
import "swiper/css/autoplay";

function rand(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

function imgUrl() {
  const id = rand(1, 200);
  return `https://picsum.photos/id/${id}/1920/1080`;
}
export const HomeSlider = (props) => {
  return (
    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      speed={1800}
    //  navigation
      autoplay={{ delay: 6000 }}
      // pagination={{ clickable: true }}
      breakpoints={{
        0: {
          slidesPerView: 1,
          // spaceBetween: 10,
        },
        480: {
          slidesPerView: 1,
          // spaceBetween: 10,
        },
        768: {
          slidesPerView: 1,
          // spaceBetween: 10,
        },
      }}
    >
    
      <SwiperSlide>
        <img className="w-full xs:h-[50vh] sm:h-[70vh] md:h-full object-cover" src=  "/images/main.jpg"alt="" />
      </SwiperSlide>
      <SwiperSlide>
        <img className="w-full xs:h-[50vh] sm:h-[70vh] md:h-full object-cover" src="/images/constuction.jpg" alt="" />
      </SwiperSlide>
      <SwiperSlide className="">
     
          <img className="w-full xs:h-[50vh] sm:h-[70vh] md:h-full object-cover" src="/images/health.jpg" alt="" />
     
      </SwiperSlide>
      <SwiperSlide>
        <img className="w-full xs:h-[50vh] sm:h-[70vh] md:h-full object-cover" src= "/images/petrolium.jpg" alt="" />
      </SwiperSlide>
      <SwiperSlide>
        <img className="w-full xs:h-[50vh] sm:h-[70vh] md:h-full object-cover" src="/images/it.jpg" alt="" />
      </SwiperSlide>
   
      <SwiperSlide>
        <img className="w-full xs:h-[50vh] sm:h-[70vh] md:h-full object-cover" src= "/images/general.jpg" alt="" />
      </SwiperSlide>
    </Swiper>
  );
};
